import Component from '@glimmer/component';
import { t } from 'ember-intl';
import SignaturePad from 'tio-common/components/signature-pad';
import type { PointGroup } from 'signature_pad';

interface PromissoryNoteSignature {
  Args: {
    onSignatureUpdate: (points: PointGroup[], dataUrl: string) => void;
    errors: string[];
  };
}

export default class LrapEnrollmentPromissoryNote extends Component<PromissoryNoteSignature> {
  <template>
    <div class="tio-col" data-test-lrap-mpn-step>
      <h2 class="app-section-title">{{t "lrap.enrollment.mpn.title"}}</h2>
      <p class="tio-lrap-intro">{{t "lrap.enrollment.mpn.intro"}}</p>

      {{! TODO: Replace with MPN document content fetched from API }}
      <div class="tio-col-tight tio-lrap-mpn-document" data-test-mpn-content>
        <p class="tio-lrap-mpn-document__heading">{{t "lrap.enrollment.mpn.document_heading"}}</p>
        <p>{{t "lrap.enrollment.mpn.document_body"}}</p>
      </div>

      <div class="tio-col">
        <p class="tio-lrap-intro">{{t "lrap.enrollment.mpn.sign_instruction"}}</p>
        <SignaturePad @onSignatureUpdate={{@onSignatureUpdate}} @errors={{@errors}} />
      </div>
    </div>
  </template>
}
